var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-12 24.292 -.075)",
    fill: "#1D83EA",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9 14.277c.421-.55.624-1.138.598-1.744-.026-.667-.319-1.19-.56-1.51.28-.712.388-1.832-.546-2.701-.684-.637-1.846-.922-3.455-.843-1.131.052-2.078.268-2.117.276-.219.04-.447.088-.68.14-.017-.28.03-.978.538-2.55.603-1.871.568-3.303-.111-4.26C12.852.079 11.712 0 11.377 0c-.323 0-.62.136-.83.386-.478.567-.422 1.612-.362 2.095-.568 1.555-2.16 5.367-3.507 6.425a.464.464 0 00-.069.061c-.179.194-.366.454-.562.783a2 2 0 00-.28 1.022v8.782a1 1 0 00.79.978l.401.086c.155.022 2.908.378 5.735.32.512.04.994.062 1.441.062.77 0 1.442-.061 2.001-.184 1.317-.286 2.216-.857 2.672-1.696a2.736 2.736 0 00.293-1.681c.856-.79 1.006-1.665.976-2.28a3.02 3.02 0 00-.176-.882z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.364,
    width: 5,
    height: 10,
    rx: 1
  }))));
}
export default SvgLikeFilled;